const shuttleReports = {
  actions: {
    export: 'ייצא',
  },

  table: {
    headers: {
      tripId: 'מזהה נסיעה',
      routingType: 'סוג הפקה',
      reservationId: 'מזהה הזמנה',
      externalId: 'מזהה חיצוני',
      reservationStatus: 'סטטוס הזמנה',
      tripStatus: 'סטטוס נסיעה',
      date: 'תאריך',
      dateType: 'סוג תאריך',
      passenger: 'נוסע',
      email: 'אימייל',
      phone: 'טלפון',
      seats: 'מושבים',
      supplier: 'ספק',
      shuttle: 'שאטל',
      line: 'קו',
      from: 'מ-',
      to: 'אל',
      driver: 'נהג',
      vehicle: 'רכב',
      paymentType: 'סוג תשלום',
      paymentDetails: 'פרטי תשלום',
      profile: 'פרופיל',
      shuttleArea: 'אזור',
      dropOff: 'הורדה',
      area: 'אזור',
      direction: 'כיוון',
      price: 'מחיר',
      pickedTime: 'זמן איסוף',
      droppedTime: 'זמן הורדה',
      noshowTime: 'זמן אי-הופעה',
      shuttleFare: 'תעריף שאטל',
    },

    cells: {
      reservationStatus: {
        options: {
          new: 'חדש',
          onhold: 'בהמתנה',
          cancelled: 'בוטל',
          routing: 'בהפקה',
          routed: 'נותב',
          picked: 'נאסף',
          dropped: 'הורד',
          noshow: 'לא הופיע',
        },
      },
    },

    filters: {
      reservationStatus: {
        options: {
          new: 'חדש',
          onhold: 'בהמתנה',
          cancelled: 'בוטל',
          routing: 'בהפקה',
          routed: 'נותב',
          picked: 'נאסף',
          dropped: 'הורד',
          noshow: 'לא הופיע',
        },
      },
      tripStatus: {
        options: {
          new: 'חדש',
          inroute: 'בנסיעה',
          sent: 'נשלח',
          approved: 'מאושר',
          pickingUp: 'אוסף',
          done: 'בוצע',
          cancelled: 'בוטל',
        },
      },
      routingType: {
        options: {
          bus: 'אוטובוס',
          demand: 'ביקוש',
          dynamic: 'דינמי',
        },
      },
    },
  },
  tableSummary: {
    title: 'דוחות שאטל',
    headers: {
      trips: 'נסיעות',
      reservations: 'הזמנות',
      passengers: 'נוסעים',
      uniquePassengers: 'נוסעים ייחודיים',
    },
  },
};

export default shuttleReports;
